import { globalStyles } from './globalStyles';
import { normalizeCSS } from './normalizeCSS';
export var staticStyles = [normalizeCSS, globalStyles];
//# sourceMappingURL=index.js.map
